import url from './url';



export default url(() => '/featured/priorities');
